import { Reveal } from "./Shared";

const CHAPTERS = [
  {
    n: "01",
    title: "Une seule plateforme",
    body: "TIRERA GROUP réunit toutes ses applications au sein d'un même écosystème. Une identité commune, une expérience cohérente, un point d'entrée unique pour tous ses utilisateurs.",
  },
  {
    n: "02",
    title: "Conçu pour l'Afrique",
    body: "Depuis Bamako, nous construisons des solutions pensées pour les réalités locales — du transport urbain à l'immobilier, du commerce à la vie spirituelle.",
  },
  {
    n: "03",
    title: "Des données unifiées",
    body: "Chaque application transmet ses données à un backend commun. Le résultat : un tableau de bord centralisé et des statistiques fiables à l'échelle du groupe.",
  },
  {
    n: "04",
    title: "Au service du quotidien",
    body: "Se déplacer, se loger, construire, acheter, prier. Nos activités accompagnent chaque moment de la vie, avec simplicité, confiance et innovation.",
  },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr]">
        <Reveal>
          <div className="lg:sticky lg:top-28">
            <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Notre vision</div>
            <h2 className="mt-4 font-display font-semibold tracking-tight text-navy text-3xl sm:text-4xl lg:text-5xl">
              Un véritable écosystème numérique malien.
            </h2>
            <p className="mt-5 text-muted-foreground leading-relaxed max-w-md">
              TIRERA GROUP développe et fait grandir cinq activités complémentaires,
              unies par une même ambition : simplifier la vie de chacun.
            </p>
          </div>
        </Reveal>

        <div className="divide-y divide-border border-t border-border">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} i={i}>
              <div className="grid grid-cols-[auto_1fr] gap-6 py-8">
                <span className="font-display text-lg font-semibold text-navy/25 tabular-nums">{c.n}</span>
                <div>
                  <h3 className="font-display font-semibold text-xl text-navy">{c.title}</h3>
                  <p className="mt-2 text-muted-foreground leading-relaxed">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
